import React from 'react';
import queryString from 'query-string';
import {Link, useLocation} from "react-router";
import {PaginationProps} from "../types";

export const Pagination: React.FC<PaginationProps> = ({
                                                   pageCount,
                                                   current,
                                                   first,
                                                   last,
                                                   pagesInRange,
                                                   firstPageInRange,
                                                   lastPageInRange,
                                               }: PaginationProps) => {



    const location = useLocation();
    const queryObject = queryString.parse(location.search);
    if(pageCount <= 1) {
        return null;
    }

    return (
        <div className="pagination">
            <ul className="pagination__list">
                {/* Previous Arrow */}
                <li
                    className={`pagination__item ${current === first ? 'm-disabled' : ''}`}
                >
                    <Link to={`${location.pathname}?${queryString.stringify({ ...queryObject, page: current - 1 })}`} className="pagination__arrow" aria-label="Previous page">
                        <svg role="img" className="pagination__arrow-ico">
                            <use href="./img/sprite.svg#arr_left"></use>
                        </svg>
                    </Link>
                </li>

                {/* Page Links */}
                {firstPageInRange > first && (
                    <>
                        <li className="pagination__item">
                            <Link to={`${location.pathname}?${queryString.stringify({ ...queryObject, page: first })}`} className="pagination__link">
                                {first}
                            </Link>
                        </li>
                        <li className="pagination__item">
                            <span className="pagination__dots">...</span>
                        </li>
                    </>
                )}

                {Object.values(pagesInRange).map((page) => (
                    <li
                        key={page}
                        className={`pagination__item ${page === current ? 'm-current' : ''}`}
                    >
                        <Link to={`${location.pathname}?${queryString.stringify({ ...queryObject, page })}`} className="pagination__link">
                            {page}
                        </Link>
                    </li>
                ))}

                {lastPageInRange < last && (
                    <>
                        <li className="pagination__item">
                            <span className="pagination__dots">...</span>
                        </li>
                        <li className="pagination__item">
                            <Link to={`${location.pathname}?${queryString.stringify({ ...queryObject, page: last })}`} className="pagination__link">
                                {last}
                            </Link>
                        </li>
                    </>
                )}

                {/* Next Arrow */}
                <li
                    className={`pagination__item ${current === last ? 'm-disabled' : ''}`}
                >
                    <Link to={`${location.pathname}?${queryString.stringify({ ...queryObject, page: current + 1 })}`} className="pagination__arrow" aria-label="Next page">
                        <svg role="img" className="pagination__arrow-ico">
                            <use href="./img/sprite.svg#arr_right"></use>
                        </svg>
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default Pagination;
